export default {
    login_register: 'Inloggen/Registreren',
    booking_confirmation_title: 'Boekingsbevestiging',
    booking_confirmation_body: 'Bedankt voor uw boeking. Hieronder vindt u de bevestigingsgegevens.',
    insurance_requirements_modal_disclaimer: `Door deze boeking te maken, bevestig ik dat: ik de afgelopen 5 jaar geen veroordelingen of verkeersovertredingen heb gehad. Ik heb geen afgewezen voorstel, geannuleerde polis of geweigerde verlenging gehad, en geen verhoogde premie of speciale voorwaarden opgelegd gekregen door een verzekeraar. Ik ben niet gediskwalificeerd om te rijden. Er loopt geen rechtszaak of politieonderzoek tegen mij. Ik ben de afgelopen 5 jaar niet veroordeeld voor diefstal, fraude of oneerlijkheid. Ik heb geen last van slecht zicht of gehoor (niet gecorrigeerd met bril of gehoorapparaat), hartproblemen, diabetes, aanvallen of enige lichamelijke of geestelijke beperking. Ik heb de afgelopen 5 jaar geen ongelukken gehad. Klik {0} als u niet aan deze eisen voldoet.`,
    insurance_requirements_here: 'hier',
    insurance_requirements: 'Ik heb de {0} gelezen en begrepen',
    ir: 'Verzekeringseisen',
    location: 'Locatie',
    pickup_location: 'Ophaallocatie',
    dropoff_location: 'Inleverlocatie',
    vehicle: 'Voertuig',
    pickup_and_dropoff: 'Ophalen en inleveren (lokale tijd)',
    view_voucher: 'Bekijk voucher',
    identity_verification_body: 'U dient uw identiteit te verifiëren voordat u het voertuig ophaalt',
    identity_verification_title: 'Identiteit verifiëren',
    search_again: 'Opnieuw zoeken',
    refrigerated: 'gekoeld',
    aircon_lower: 'airco',
    aircon: 'Airco',
    refrigeration: 'Gekoeld',
    not_available: 'Drive & Go is momenteel alleen beschikbaar voor personen met identiteits- en rijbewijsdocumenten uit de volgende landen.',
    check_if_included: 'Controleer of uw land is opgenomen.',
    included_in_booking: 'Inbegrepen bij deze boeking',
    cdw_with_excess: 'CDW met eigen risico',
    theft_protection: 'Diefstalbescherming met eigen risico',
    risk_reduction: 'Risicoreductie',
    free_extras: "U heeft recht op twee gratis extra's <br /> bij deze boeking.",
    continue: 'Doorgaan',
    luggage_large_short_label: 'G',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'K',
    luggage_large_long_label: 'groot',
    luggage_medium_long_label: 'middelgroot',
    luggage_small_long_label: 'klein',
    fuel_unspecified_label: 'niet gespecificeerd',
    transmission_manual_label: 'Handgeschakeld',
    transmission_automatic_label: 'Automaat',
    make_a_booking: 'Boeking maken',
    pickup_date: 'Ophaaldatum',
    dropoff_date: 'Inleverdatum',
    driver_age: 'Bestuurder tussen 30 - 65',
    enter_driver_age: 'Voer de leeftijd van de bestuurder in',
    promo_code: 'Promotiecode',
    search: 'Zoeken',
    dropoff_date_cannot_be_before_pickup_date: 'De inleverdatum kan niet vóór de ophaaldatum zijn',
    pickup_date_cannot_be_in_the_past: 'De ophaaldatum kan niet in het verleden liggen',
    pickup_time_cannot_be_in_the_past: 'De ophaaltijd kan niet in het verleden liggen',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'De inlevertijd moet later zijn dan de ophaaltijd als het op dezelfde dag is',
    vehicle_filters: 'Voertuigfilters',
    reset: 'Resetten',
    transmission: 'Transmissie',
    all: 'Alle',
    manual: 'Handgeschakeld',
    auto: 'Automaat',
    passengers: 'Passagiers',
    vehicle_type: 'Voertuigtype',
    filter: 'Filter',
    vehicle_search: 'Voertuig zoeken',
    edit: 'Bewerken',
    no_results: 'Geen resultaten gevonden voor uw filtercriteria.',
    small_cars: "Kleine auto's",
    medium_cars: "Middelgrote auto's",
    large_cars: "Grote auto's",
    estate_cars: 'Stationwagens',
    suvs: "SUV's",
    mpvs: "MPV's",
    vans: 'Bestelwagens',
    camper_vans: 'Campers',
    premium: 'Premium',
    unspecified: 'niet gespecificeerd',
    large: 'groot',
    medium: 'middelgroot',
    small: 'klein',
    automatic: 'automaat',
    you_have_been_refunded: 'U bent terugbetaald.',
    please_customer_service: 'Neem contact op met onze klantenservice om een boeking te maken.',
    contact_customer_service: 'Contact klantenservice',
    booking_failed: 'Uw boeking kon niet worden verwerkt.',
    summary: 'Samenvatting',
    reforestation_and_protection: 'Steun herbebossing en bescherming van het regenwoud in heel Costa Rica',
    cost_of_rental: 'Huurprijs',
    to_pay_now: 'Nu te betalen',
    greenheart_donation: 'Green Heart donatie',
    total_cost: 'Totale huurprijs',
    tc_agreement: 'Ik heb de {0} gelezen en begrepen.',
    tc: 'Algemene voorwaarden',
    receive_offers: 'Ik ontvang graag speciale aanbiedingen per e-mail.',
    donate: 'Ja, ik wil {amount} doneren',
    pay_now: 'Betaal nu {amount}',
    driver_details: 'Gegevens bestuurder',
    complete_driver_details: 'Vul de gegevens van de bestuurder in.',
    are_you_the_driver: 'Bent u de bestuurder?',
    have_an_account: 'Heeft u al een account?',
    login: 'Inloggen',
    or: 'of',
    first_name: 'Voornaam bestuurder',
    last_name: 'Achternaam bestuurder',
    email: 'E-mailadres',
    phone_number: 'Mobiel telefoonnummer',
    unable_to_save_driver_information: 'Kan de gegevens van de bestuurder niet opslaan. Probeer het opnieuw.',
    pay_online_now: 'Nu betalen',
    day: 'Dag',
    choose_location: 'Kies een locatie',
    location_not_found: 'Sorry, we konden de opgegeven locatie niet vinden.',
    add: 'Toevoegen',
    remove: 'Verwijderen',
    free_extra: 'Gratis extra',
    free: 'GRATIS!',
    fast_track_notice: 'Documenteisen gelden voor deze service. Alleen beschikbaar voor personen met documenten uit',
    complete_booking: 'Boeking afronden',
    choose_card: 'Kies een kaart of voeg een nieuwe toe.',
    add_billing_details: 'Voeg factuurgegevens toe.',
    card_number: 'Kaartnummer',
    card_holder_name: 'Naam kaarthouder',
    card_exp: 'MM / JJ',
    card_cvc: 'CVC',
    save_card: 'Kaart opslaan?',
    amount_charged: 'Uw kaart wordt belast',
    payment_confirmation: 'Bevestig boeking en betaal',
    payment_methods: 'beschikbare betaalmethoden',
    use_saved_card: 'x opgeslagen kaart gebruiken',
    use_different_card: '+ andere kaart gebruiken',
    book_now: 'Nu boeken',
    minimum_age: 'Alleen voor {age}+',
    excess_liability: 'Eigen risico',
    security_deposit: 'Borg',
    fuel_policy: 'Brandstofbeleid',
    like_for_like: 'Zoals ontvangen',
    full_to_full: 'Vol-vol',
    miles_per_rental: '{mileage} gratis mijlen per huur',
    km_per_rental: '{mileage} gratis km per huur',
    unlimited_mileage: 'Onbeperkt aantal kilometers',
    unlimited_mileage_km: 'Onbeperkt aantal km',
    non_amendable: 'Niet aanpasbaar',
    non_refundable: 'Niet restitueerbaar',
    free_cancellation_until: 'Gratis annuleren tot',
    cancellation_in_line_with: 'Annulering volgens',
    tcs: 'Algemene voorwaarden',
    free_extras_on_collection: "Twee gratis extra's bij ophalen",
    glass_and_tyres_covered: 'Ruiten en banden gedekt',
    number_of_passengers: 'Aantal passagiers',
    number_of_bags: 'Aantal tassen',
    fuel_type: 'Brandstoftype',
    co2: 'CO2',
    book_type: 'Boek {type}',
    processing: 'Bezig met verwerken',
    actual_price: 'Werkelijke prijs',
    tooltip: 'Prijs in {currencyCode} is een schatting op basis van de wisselkoers, de prijs in {currency} is bindend.',
    deposit: 'Borg',
    pay_online: 'Nu betalen',
    pay_online_without_extras: 'Huurprijs',
    extras_on_arrival: "Extra's bij aankomst",
    insurance_on_arrival: 'Risicoreductie - betalen bij aankomst',
    insurance_online: 'Risicoreductie - nu betalen',
    extras_online: "Extra's nu betalen",
    green_heart_donation: 'Green Heart donatie',
    why_use_drive_and_go: 'Waarom Drive & Go gebruiken?',
    straight_to_car: 'Direct naar de auto',
    no_queues: 'Geen wachtrijen',
    self_checkout: 'Zelfservice ophalen',
    cant_lose_key: 'Sleutel kan niet kwijt',
    online_id_check: 'Online ID-controle',
    phone_as_key: 'Telefoon als sleutel',
    premiumplus_benefits_includes: 'Inclusief Premium Plus+ voordelen',
    book_drive_go: 'Boek Drive & Go',
    distance_allowance: 'Toegestane afstand',
    duration: 'Duur',
    view_more_bookings: 'Meer boekingen bekijken',
    to_pay_on_arrival: 'Te betalen bij aankomst',
    pay_on_arrival: 'Betalen bij aankomst',
    unlimited: 'Onbeperkt',
    return_date: 'Retourdatum',
    postcode: 'Postcode',
    country: 'Land',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go is momenteel alleen beschikbaar voor personen met identiteits- en rijbewijsdocumenten uit de volgende landen:',
        drive_and_go_today: 'Drive & Go boeking vandaag!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Waarom Drive & Go gebruiken?',
        straight_to_car: 'Direct naar de auto',
        no_queues: 'Geen wachtrijen',
        self_checkout: 'Zelfservice ophalen',
        cannot_lose_the_key: 'Sleutel kan niet kwijt',
        online_id_check: 'Online ID-controle',
        phone_as_a_key: 'Telefoon als sleutel',
        premium_plus_benefits_also_included: 'Inclusief Premium Plus+ voordelen',
        book_drive_and_go: 'Boek Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tent en uitrusting',
        quick_and_easy: 'Snel en eenvoudig op te zetten',
        travel_freedom: 'Reisvrijheid',
        affordable_campervan_alternative: 'Betaalbaar alternatief voor een camper',
        lightweight_and_compact: 'Licht en compact',
        fully_insured: 'Volledig verzekerd',
    },
    my_bookings: 'Mijn boeking',
    no_bookings: 'Geen boeking',
    my_profile: 'Mijn profiel',
    no_bookings_to_display: 'Geen boekingen om weer te geven.',
    search_great_car_rental_deals: 'Zoek geweldige autoverhuuraanbiedingen voor uw volgende reis.',
    odometer_at_collection: 'Kilometerteller bij ophalen',
    fuel_at_collection: 'Brandstof bij ophalen',
    start_check_in: 'Check-in starten',
    start_collection: 'Ophalen starten',
    recent_bookings: 'Recente boeking',
    damage: {
        updated_damage_report_submitted: 'Een bijgewerkt schaderapport is ingediend. Een medewerker van onze klantenservice neemt indien nodig contact met u op.',
        add_additional_damage: 'Extra schade toevoegen',
        you_may_report_additional_damage_up_to: 'U kunt extra schade melden tot 24 uur na het ophalen van het voertuig',
        specify_damage: 'Specificeer schade',
        please_choose_the_area_and_type_of_damage: 'Kies het gebied en het type schade',
        type_of_damage: 'Type schade',
        is_this_more_than_5_cm: 'Is dit meer dan 5 cm?',
        please_take_or_select_a_photo: 'Maak of selecteer een foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Maak een foto waarop de schade duidelijk zichtbaar is',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Indien nodig kunt u nog een foto toevoegen, selecteer het pictogram om een extra foto toe te voegen',
        save_image: 'Afbeelding opslaan',
        save_images: 'Afbeeldingen opslaan',
        damage_saved_successfully: 'Schade succesvol opgeslagen',
        add_photo: 'Foto toevoegen',
    },
    checkout: {
        start_collection: 'Ophalen starten',
        collect_vehicle: 'Voertuig ophalen',
        we_will_let_you_know_the_details: 'We laten u weten waar en hoe u het huurvoertuig kunt vinden.',
        inspect: 'Inspecteren',
        we_will_ask_for_four_photos_from_each_corner: "We vragen om vier foto's van elke hoek van het voertuig en eventuele nieuwe schade die nog niet is gemeld.",
        fuel_and_milage: 'Brandstof & kilometerstand',
        you_confirm_the_readings_at_the_start_of_your_hire: 'U bevestigt de kilometerstand en brandstof bij aanvang van de huur.',
        sign: 'Ondertekenen',
        sign_the_rental_agreement: 'Onderteken de huurovereenkomst.',
        away_you_go: 'Goede reis',
        you_are_free_to_take_to_the_road: 'U kunt de weg op!',
        collect_your_vehicle: 'Haal uw voertuig op',
        get_directions: 'Routebeschrijving',
        hide_directions: 'Routebeschrijving verbergen',
        local_time: 'lokale tijd',
        tel: 'Tel',
        getting_to_the_location: 'Naar de locatie gaan',
        get_vehicle_details: 'Voertuiggegevens ophalen',
        view_map: 'Bekijk kaart',
        unlock_vehicle_and_continue: 'Voertuig ontgrendelen & doorgaan',
        unable_to_connect_to_vehicle: 'Kan geen verbinding maken met voertuig',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Kan geen verbinding maken met het voertuig - controleer of u bij het juiste voertuig staat en probeer het opnieuw.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'We konden de voertuigboeking niet vinden. Probeer het later opnieuw.',
        odometer_and_fuel: 'Kilometerteller & brandstof',
        odometer: 'Kilometerteller',
        please_confirm_the_odometer_and_fuel_readings: 'Bevestig indien mogelijk de kilometerstand en brandstof.',
        the_odometer_field_is_required: 'Het veld kilometerteller is verplicht',
        and_must_be_greater_than_the_checkout_odometer: 'en moet groter zijn dan de kilometerteller bij ophalen',
        confirm: 'Bevestigen',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Maak een foto van elke hoek van het voertuig',
        pre_existing_damage: 'Bestaande schade',
        no_pre_existing_damage: 'Geen bestaande schade.',
        new_damage: 'Nieuwe schade',
        add_additional_damage: 'extra schade toevoegen',
        no_new_damage_to_report: 'Geen nieuwe schade te melden',
        checkout_complete: 'Ophalen voltooid',
        start_rental: 'Huur starten',
        congratulations_name_it_is_time_to_take_to_the_road: 'Gefeliciteerd {customer_name}, u kunt op weg!',
        we_are_unable_to_complete_your_vehicle_checkout: 'We kunnen het ophalen van uw voertuig niet voltooien.',
        please_do_the_following: 'Doe het volgende',
        remove_all_belonging_and_lock_the_vehicle: 'Verwijder alle spullen en vergrendel het voertuig.',
        lock_vehicle: 'Voertuig vergrendelen',
        once_you_have_contacted_customer_services: 'Nadat u contact heeft opgenomen met de klantenservice',
        vehicle_location: 'Voertuiglocatie',
        collect_your: 'Haal uw',
        from: 'Van',
        key_in_glove_box: 'uw sleutel bevindt zich in het dashboardkastje',

        keyholder: {
            not_detected: 'Sleutel niet gedetecteerd in sleutelhouder',
            not_detected_please_try_again: 'Plaats uw sleutel in de sleutelhouder en probeer het opnieuw.',

            not_installed: 'Sleutelhouder niet geïnstalleerd',
            not_installed_please_contact_customer_service: 'Sleutelhouder is niet geïnstalleerd, neem contact op met de klantenservice.',
        },
        keyring: {
            look_up_failed: 'Sleutelring niet gevonden',
            look_up_failed_please_contact_customer_service: 'Sleutelring niet gevonden, neem contact op met de klantenservice.',
        },
        key: {
            invalid: 'Sleutel is ongeldig',
            invalid_please_contact_customer_service: 'Uw sleutel is ongeldig, neem contact op met de klantenservice.',

            expired: 'Sleutel is verlopen',
            expired__please_contact_customer_service: 'Uw sleutel is verlopen, neem contact op met de klantenservice.',
        },
    },
    checkin: {
        start_check_in: 'Check-in starten',
        vehicle_location: 'Voertuiglocatie',
        tell_us_where_you_have_parked: 'Vertel ons waar u het voertuig heeft geparkeerd.',
        fuel_and_milage: 'Brandstof & kilometerstand',
        you_confirm_the_readings_at_the_end_of_your_hire: 'U bevestigt de kilometerstand en brandstof aan het einde van de huur.',
        inspect: 'Inspecteren',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: "We vragen om vier foto's van elke hoek van het voertuig en eventuele nieuwe schade tijdens de huur.",
        lock: 'Vergrendelen',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Controleer of u geen spullen heeft achtergelaten en vergrendel het voertuig.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Vertel ons waar u het voertuig heeft geparkeerd',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Als het voertuig is vergrendeld, kunt u het niet opnieuw ontgrendelen.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, controleer of u geen spullen heeft achtergelaten, vergrendel het voertuig en breng indien nodig de fysieke sleutel terug naar de sleutelhouder.',
        lock_vehicle: 'Voertuig vergrendelen',
        complete_check_in: 'Check-in voltooien',
        inspection: 'Inspectie',
        complete_vehicle_check_in: 'Voertuig check-in voltooien',
        we_are_unable_to_complete_your_vehicle_check_in: 'We kunnen uw voertuig check-in niet voltooien.',
        please_contact_customer_services: 'Neem contact op met de klantenservice',
        once_you_have_contacted_customer_services: 'Nadat u contact heeft opgenomen met de klantenservice',
        please_amend_odometer_to_be_greater_than: 'Pas de kilometerteller aan naar meer dan {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Huurovereenkomst',
        agreement_between: 'Overeenkomst tussen',
        and: 'en',
        sign_rental_agreement: 'Huurovereenkomst ondertekenen',
        i_have_read_and_understood_the_terms_and_conditions: 'Ik heb de algemene voorwaarden gelezen en begrepen en accepteer de staat van het voertuig',
    },
    additional_options: 'Aanvullende opties',
    booking_details: 'Boekingsgegevens',
    price_for_x_days: 'Prijs voor {qty_of_days} dag | Prijs voor {qty_of_days} dagen',
    cancelled: 'Geannuleerd',
    upcoming: 'Aankomend',
    active: 'Actief',
    full_insurance_no_deposit: 'Volledige verzekering & geen borg vereist',
    excess: '{amount} eigen risico',
    deposit: '{amount} borg',
    included_daily_distance: '{distance} {unit} per dag',
    miles: 'mijlen',
    kilometers: 'kilometers',
    collection_details_title: 'Ophaalgegevens',
    collection_details_not_found: 'Geen ophaalgegevens gedefinieerd voor deze locatie',
    free_cancellation: 'Gratis annuleren',
    no_deposit: 'Geen borg',
    benefit_from: 'Profiteer van',
    for_only_per_day: 'Voor slechts {price} per dag',
    upgrade_mee: 'UpgradeMee',
};
